import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from '@shopify/app-bridge-react';

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const shop = searchParams.get('shop');
    const host = searchParams.get('host');
    const error = searchParams.get('error');

    const baseUrl = window.location.origin + (window.location.pathname.replace(/\/auth\/callback\/?$/, '') || '/');
    const appRoot = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) || '/' : baseUrl;

    const params = new URLSearchParams();
    if (shop) params.set('shop', shop);
    if (host) params.set('host', host);
    if (error) params.set('error', error);
    const query = params.toString();
    const redirectUrl = query ? `${appRoot}?${query}` : appRoot;

    // App Bridge useNavigate handles embedded iframe redirect correctly
    navigate(redirectUrl);
  }, [searchParams, navigate]);

  return (
    <div
      style={{
        fontFamily: 'system-ui, sans-serif',
        maxWidth: 400,
        margin: '80px auto',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <p style={{ color: '#666' }}>Redirecting to app...</p>
    </div>
  );
}
